import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export interface showSupplier {
    name?: string;
    account_no?: string;
    serial_no?: string;
    phone?: string;
    fax?: string;
    mobile?: string;
    email?: string;
    website?: string;
    country?: string;
    government?: string;
    city?: string;
    postal_code?: string;
    department_number?: string;
    address_1?: string;
    address_2?: string;
    address_3?: string;
}

// Show supplier state
export interface showSupplierState {
    isLoaded: boolean;
    isOpen: boolean;
    id: number;
    data: showSupplier;
}

const initialShowSupplierState: showSupplierState = {
    isLoaded: false,
    isOpen: false,
    id: 0,
    data: {
        
    }
}

// Show supplier slice
export const showSupplierSlice = createSlice({
    name: 'show_supplier',
    initialState: initialShowSupplierState,
    reducers: {
        setIsLoaded: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoaded = payload
        },
        setData: ( state, {payload}: PayloadAction<showSupplier> ) => {
            state.data = payload
        },
        setIsOpen: ( state, {payload}: PayloadAction<{ id: number, isOpen: boolean }> ) => {
            state.isOpen = payload.isOpen
            state.id = payload.id
        }
    }
})